/* unplugin-vue-components disabled */import script from "./AppletsCode.vue?vue&type=script&setup=true&lang=js"
export * from "./AppletsCode.vue?vue&type=script&setup=true&lang=js"

import "./AppletsCode.vue?vue&type=style&index=0&id=29e2c7df&lang=scss"

const __exports__ = script;

export default __exports__